import React from 'react';

import PhoneNumber from '../../../../../../components/phone-number/phone-number';
import SearchButton, {
  SearchButtonGroup
} from '../../../../../../components/search-button/search-button';
import CommentsDuotoneIcon from '../../../../../../shared/icons/comments-duotone-icon';
import PhoneSolidIcon from '../../../../../../shared/icons/phone-solid-icon';
import Button from '../../../../../button/button';
import Typography from '../../../../../typography/typography';
import { TABS } from '../../../../fitment-constants';

import { useMyStore } from '../../../../../../shared/hooks/hooks';

import './fitment-cant-find-alternate-shop-options.scss';

type TabOption = keyof typeof TABS;

interface FitmentCantFindAlternateShopOptionsProps {
  className?: string;
  onShopByClick: (tab: TabOption) => void;
}

function FitmentCantFindAlternateShopOptions(
  props: FitmentCantFindAlternateShopOptionsProps
) {
  const { className = '', onShopByClick } = props;

  const { myStore } = useMyStore();

  const lpChatButton: HTMLButtonElement | null = document.querySelector(
    '[aria-label="CHAT"]'
  );

  return (
    <div
      className={`fitment-cant-find-alternate-shop-options ${className}`}
      data-testid="fitment-cant-find-alternate-shop-options"
      styleName="container"
    >
      <Typography styleName="contact-ctas" tag="div" variant="H6">
        <div>
          <PhoneSolidIcon styleName="phone-icon" />
          <PhoneNumber phone={myStore?.address?.phone} styleName="phone" />
        </div>
        {lpChatButton && (
          <div>
            <CommentsDuotoneIcon styleName="chat-icon" />
            <Button onClick={() => lpChatButton.click?.()} size="regular">
              Chat with us!
            </Button>
          </div>
        )}
      </Typography>

      <SearchButtonGroup>
        <SearchButton
          label="Shop by Size"
          onClick={() => onShopByClick('SIZE')}
        >
          <img
            alt="Choose Tires"
            src="https://www.tirerack.com/images/css_elements/tireSizeHelpGraphic2.png"
            width="100%"
          />
        </SearchButton>
        <SearchButton
          label="Shop by Brand"
          onClick={() => onShopByClick('BRAND')}
        >
          <img
            alt="Choose Tires"
            src="https://discounttire.scene7.com/is/image/discounttire/T_G_hero_tire_basics_001?wid=200&resMode=sharp2&op_usm=1.25,0.3,2,0"
          />
        </SearchButton>
      </SearchButtonGroup>
    </div>
  );
}

export default FitmentCantFindAlternateShopOptions;
